import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Global from '../../../../../store/global-selectors';

// NOTE: THESE VALUES ARE HARDCODED FOR NOW TO LAY GROUNDWORK FOR FUTURE INSURANCE PROVIDERS
// ONCE OTHER INSURANCE PROVIDERS ARE SUPPORTED, WE SHOULD HAVE AN API CALL TO GET THESE FROM THE BE
import { FAKE_SHIPSURANCE_INSURANCE_PROVIDER_ID } from '../../../../../components/data-driven-logo/fake-shipsurance-info';

const FAKE_SELLER_INSURANCE_PROVIDER_ID = '1';

const useSellerInsuranceProviders = () => {
  const shipsuranceBalanceInfo = useSelector(Global.selectSellerShipsuranceAccountInfo);
  const hasPersonalShipsuranceAccount = useSelector(Global.selectSellerPersonalShipsuranceAccount);

  // Note: this can be replaced with an API call when we support multiple insurance providers
  return useMemo(() => {
    if (hasPersonalShipsuranceAccount) {
      return [];
    }

    return [
      {
        balance: shipsuranceBalanceInfo?.balance,
        sellerInsuranceProviderId: FAKE_SELLER_INSURANCE_PROVIDER_ID,
        insuranceProviderId: FAKE_SHIPSURANCE_INSURANCE_PROVIDER_ID,
      },
    ];
  }, [shipsuranceBalanceInfo, hasPersonalShipsuranceAccount]);
};

export default useSellerInsuranceProviders;
